var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"close-btn",attrs:{"to":"/"}},[_c('v-icon',{staticClass:"margin-header icon-size",attrs:{"color":"var(--purple-color)","x-large":""}},[_vm._v(" mdi-window-close ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }